import { navigateTo } from "context/navigation.service";
import type { RecallCampaignGroup } from "@services/api/recallCampaigns";

export default function RecallCampaignsWidget({ campaigns }: { campaigns: RecallCampaignGroup[] }) {
  return (
    <div className="flex flex-col bg-white border rounded-xl p-4 gap-2 shadow-lg">
      <div className="flex flex-row justify-between items-center mb-1">
        <div className="font-semibold text-black">Campagnes de rappel</div>
        {campaigns.length > 0 && (
          <span className="text-h4 font-medium rounded-full px-2 py-0.5" style={{ background: "#FEE2E2", color: "#991B1B" }}>
            {campaigns.reduce((sum, c) => sum + c.total - c.treated, 0)} en cours
          </span>
        )}
      </div>
      {campaigns.length === 0 && (
        <div className="text-h3 text-neutral-400 py-2">Aucune campagne de rappel active</div>
      )}
      {campaigns.map((c) => (
        <div key={c.campaign_code} className="flex flex-col p-2 rounded-lg gap-1" style={{ background: c.treated < c.total ? "#FEF2F2" : "#F0FDF4" }}>
          <div className="flex flex-row items-center justify-between">
            <div className="text-h2 font-semibold text-black">{c.campaign_code}</div>
            <span className="text-h4 font-medium" style={{ color: c.treated < c.total ? "#991B1B" : "#065F46" }}>
              {c.treated}/{c.total} traités
            </span>
          </div>
          <div className="text-h3 text-neutral-500">{c.campaign_title}</div>
          <div className="flex flex-row flex-wrap gap-1 mt-1">
            {c.vehicles.slice(0, 5).map((v) => (
              <span
                key={v.id}
                className="text-h5 font-medium rounded-full px-2 py-0.5 cursor-pointer hover:opacity-80"
                style={{
                  background: v.status === "treated" ? "#D1FAE5" : "#FEE2E2",
                  color: v.status === "treated" ? "#065F46" : "#991B1B",
                }}
                onClick={() => v.ordre_id && navigateTo({ route: `/ordre/${v.ordre_id}` })}
              >
                {v.plate || v.vin?.slice(0, 8)}
              </span>
            ))}
            {c.vehicles.length > 5 && (
              <span className="text-h5 text-neutral-400">+{c.vehicles.length - 5}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
